import API from 'app/utils/apiClient';

import { toParams } from 'app/utils/url';

const getExchanges = (page = 1, perPage = 20) => {
  const params = toParams({ page, perPage });
  return API.get(`/users/me/exchanges/?${params}`);
};

const exchange = (balloon, dueDate) =>
  API.post('/exchanges/', {
    balloon,
    dueDate,
  });

export default {
  getExchanges,
  exchange,
};



// WEBPACK FOOTER //
// ./src/app/apis/withdrawal.js